import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import configureStore, { history } from './store';
import App from './App';
import * as serviceWorker from './serviceWorker';
import './index.css';
import './i18n';
import 'react-app-polyfill/stable';
import { CookiesProvider } from 'react-cookie';

const store = configureStore();
const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <Provider store={store}>
    <CookiesProvider>
      <App history={history} />
    </CookiesProvider>
  </Provider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
